import { render, staticRenderFns } from "./EmergencyEmergencyDynamics.vue?vue&type=template&id=65113d71&scoped=true&"
import script from "./EmergencyEmergencyDynamics.vue?vue&type=script&lang=js&"
export * from "./EmergencyEmergencyDynamics.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyEmergencyDynamics.vue?vue&type=style&index=0&id=65113d71&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65113d71",
  null
  
)

export default component.exports